import { $$, $, extend, hasParentsDataset, hasParentsClass } from './helper-functions'

export class ModalVariant2 {
  constructor (settings, selectors, classes) {
    this.settings = extend({
    }, settings)

    this.selectors = extend({
      modal: '.modal--variant-2',
      container: '.modal__container',
      close: '[data-modal-close]',
      buttonOpenModal: '[data-modal-2-target]'
    }, selectors)

    this.classes = extend({
      container: 'modal__container',
      closeButton: 'modal__close',
      active: 'is--active'
    }, classes)

    this.$modals = $$(this.selectors.modal)
    this.$buttonOpenModals = $$(this.selectors.buttonOpenModal)
  }

  init () {
    this.addEvents()
  }

  addEvents () {
    // Close the modal when you click outside the container or on the close button
    $('body').addEventListener('click', (event) => {
      if (!hasParentsClass(event.target, this.classes.container) && !hasParentsDataset(event.target, 'modal-2Target')) {
        this.$modals.forEach((modal) => {
          if (modal.classList.contains(this.classes.active)) {
            const closeButtons = $$(this.selectors.close, modal)
            closeButtons.forEach((closeButton) => {
              closeButton.dispatchEvent(new Event('click'))
            })
          }
        })
      }
    })

    this.$modals.forEach((modal) => {
      const closeButtons = $$(this.selectors.close, modal)

      closeButtons.forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
          const modal = closeButton.closest(this.selectors.modal)
          if (modal) {
            const buttonOpenModals = $$('[data-modal-2-target="' + modal.dataset['modal-2'] + '"]')
            buttonOpenModals.forEach(buttonOpenModal => {
              buttonOpenModal.classList.remove(this.classes.active)
            })
            modal.classList.remove(this.classes.active)
          }
        })
      })
    })

    this.$buttonOpenModals.forEach((buttonOpenModal) => {
      buttonOpenModal.addEventListener('click', () => {
        const modalTarget = buttonOpenModal.dataset['modal-2Target']
        if (modalTarget) {
          const modal = $('[data-modal-2="' + modalTarget + '"]')
          if (modal) {
            buttonOpenModal.classList.toggle(this.classes.active)
            modal.classList.toggle(this.classes.active)
          }
        }
      })
    })
  }
}

export default ModalVariant2
